module.exports = __webpack_public_path__ + "img/DC-appointments-app.ea4da327.svg";